import styled from 'styled-components';

export const $CardList = styled.div`
  margin-top: 1rem;
  display: grid;
  gap: 0.75rem;
  min-width: 0;
  max-width: 100%;
`;

export const $Card = styled.article`
  border: 1px solid
    ${({ theme }) => theme.newUI?.inputBorderColors?.default ?? '#e5e7eb'};
  border-radius: ${({ theme }) => theme.newUI?.borders?.bigRadius ?? '10px'};
  padding: 0.9rem;
  box-sizing: border-box;
  min-width: 0;
  max-width: 100%;
  background: ${({ theme }) =>
    theme.systemColors?.defaultBackground ?? theme.colors?.white ?? '#fff'};
  box-shadow: ${({ theme }) =>
    (theme.newUI?.shadows as { level1?: string } | undefined)?.level1 ??
    '0 1px 3px rgba(0, 0, 0, 0.06)'};
`;

export const $CardButton = styled.button`
  display: block;
  width: 100%;
  min-width: 0;
  padding: 0;
  border: none;
  background: transparent;
  text-align: inherit;
  cursor: pointer;

  &:hover ${$Card} {
    border-color: ${({ theme }) => theme.colors?.primary ?? '#5369eb'};
    box-shadow: ${({ theme }) =>
      (theme.newUI?.shadows as { level2?: string } | undefined)?.level2 ??
      '0 4px 12px rgba(83, 105, 235, 0.12)'};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors?.primary ?? '#5369eb'};
    outline-offset: 2px;
    border-radius: ${({ theme }) => theme.newUI?.borders?.bigRadius ?? '10px'};
  }
`;

export const $CardStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  min-width: 0;
`;

export const $CardTopRow = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 0.75rem;
  align-items: start;
`;

export const $MetaItem = styled.div<{ $alignEnd?: boolean }>`
  min-width: 0;
  text-align: ${({ $alignEnd }) => ($alignEnd ? 'right' : 'left')};
`;

export const $MetaValue = styled.div`
  font-size: ${({ theme }) => theme.fonts?.size?.small ?? '0.875rem'};
  font-weight: ${({ theme }) => theme.fonts?.weight?.mediumFont ?? 500};
  color: ${({ theme }) => theme.newUI?.defaultColors?.text ?? theme.colors?.mainTextColor ?? '#111827'};
  word-break: break-word;
  overflow-wrap: anywhere;
`;

export const $StatutTagWrap = styled.div`
  display: flex;
  width: 100%;
  min-width: 0;

  & > div {
    width: 100%;
    height: auto;
    min-height: 1.75rem;
    padding: 0.4375rem 0.75rem;
    line-height: 1.5;
    align-items: flex-start;
  }

  & > div > span {
    line-height: 1.5;
  }
`;

export const $EmptyState = styled.div`
  margin-top: 1rem;
  padding: 1.25rem;
  text-align: center;
  color: ${({ theme }) =>
    theme.newUI?.defaultColors?.secondaryText ?? theme.colors?.paragraphTextColor ?? '#64748b'};
  font-size: ${({ theme }) => theme.fonts?.size?.small ?? '0.875rem'};
  border: 1px dashed ${({ theme }) => theme.newUI?.inputBorderColors?.default ?? '#cbd5e1'};
  border-radius: ${({ theme }) => theme.newUI?.borders?.mediumRadius ?? '8px'};
  background: ${({ theme }) => theme.newUI?.variationColors?.light5 ?? '#f8fafc'};
`;
